import documents from "./registration-documents.json";

// Identifies the exact owner-provided pair, including original dates and tables.
export const REGISTRATION_DOCUMENTS_VERSION = `2026-10-29:${documents.map(document => `${document.id}:${document.sourceSha256}`).join(";")}`;
